const translateSeverityOccurrence = occurrenceType => {
  const type = String(occurrenceType);
  switch (type) {
    case 'L':
      return 'Leve';
    case 'M':
      return 'Médio';
    case 'S':
      return 'Grave';
    case 'VS':
      return 'Gravíssimo';
    default:
      return '---';
  }
};

export default translateSeverityOccurrence;
